import React from 'react';

interface IAntiForgeryTokenProp {
    requestVerificationToken: string;
}

export default function AntiForgeryToken(props: IAntiForgeryTokenProp): JSX.Element {
    const { requestVerificationToken } = props;

    return <input type="hidden" name="__RequestVerificationToken" value={requestVerificationToken} />;
}
